package mo.web.portfoliofront.infrastructure.models

enum class SkillCategory(val label: String) {
    LANGUAGE("Languages"),
    FRAMEWORK("Frameworks"),
    DATABASE("Databases"),
    TOOL("Tools"),
    SOFT_SKILL("Soft Skills"),
}